export default __webpack_public_path__ + "static/media/BLE_PULSE.fc6387b9.png";